import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-profile-agent',
	template: `


	<div class="ui container" appMargin appPadding paddingB='30'>


    <div class='ui vertical basic segment' >
        <div fxLayout="row" fxLayoutAlign='space-between center'>
            <div fxLayoutAlign='start center' fxLayout='row' fxLayoutGap='20px'>
                <div class='equipment-id'>
					<span class="sub-item">Home > Profile</span>
                    <h2 class="ui primary header">Profile</h2>
                </div>
            </div>
		</div>

<div class="ui divider"></div>
		<div fxLayout="row" fxLayoutGap='30px'>
				<div fxFlex="20%" fxLayout='column' fxLayoutGap='10px'>

					<div class="side-panel">
					<a   *ngFor="let link of projectFields" class='ui white button' fxLayout='row' routerLink='{{link.route}}' routerLinkActive='primary' appMargin marginY='8px' appPadding paddingY='14px'>
						{{link?.name}}
					</a>
					</div>
				</div>
				<div fxFlex="grow">
					<router-outlet></router-outlet>
				</div>
			</div>

</div>

	`
})
export class ProfileComponent implements OnInit {
	permissions;
	constructor() {
		if (window.localStorage.getItem('user')) {
			let authTokenPermission = JSON.parse(localStorage.getItem('permissions'));
			// this.permissions = JSON.parse(window.localStorage.getItem("permission"));
			this.permissions = authTokenPermission;
		}
	}
	projectFields: Array<any> = [];
	menus: Array<any> = [
		{ name: 'Update Profile', route: 'detail' },
		{ name: 'User Management', route: 'user', permission: 'USERS_MANAGEMENT' },
		{ name: 'Role Management', route: 'role', permission: 'ROLES_MANAGEMENT' },
		{ name: 'Account Security', route: 'account-security' },
		{ name: 'Email Notification', route: 'notification' }
	];
	checkPermission(id: string, action: string): boolean {
		if (
			this.permissions.filter((res) => res.permissionId === id)[0] &&
			this.permissions.filter((res) => res.permissionId === id)[0][action] === 'true'
		) {
			return true;
		} else {
			return false;
		}
	}
	ngOnInit(): void {
		this.menus.forEach((menu) => {
			if (menu.permission) {
				if (this.checkPermission(menu.permission, 'read')) {
					this.projectFields.push(menu);
				}
			} else {
				this.projectFields.push(menu);
			}
		});
	}
}
